import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback, Input } from "reactstrap";

import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { saveAs } from 'file-saver';
import Papa from "papaparse";
import { formatCurrency, formatDate } from '../../Utils/formatters';

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}


const UserBonus = props => {
  //meta title
  document.title = "User Bonus";
  const { getRequest, postRequest } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });
    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, 5000);
    };


  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const [CsvData, setCsvData] = React.useState([]);

  const handleT1Body = async (tempData) => {
    setCsvData(tempData);

    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.ft_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.description}</td>
        <td>{formatCurrency(element.amount)}</td>
        <td>{element.currency_type}</td>
        <td>{formatDate(element.created_at)}</td>
        <td>{element.invest_at?formatDate(element.invest_at): '-'}</td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-user-bonus/' + atob(props.match.params.id));
    if (res && res.code === 200) {
      setCsvData(res.data)
      handleT1Body(res.data);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="10" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }

  const handleDownloadCSV = () => {

    const transformedData = CsvData.map(transaction => ({
      "First Name": transaction.first_name,
      "Last Name": transaction.last_name,
      "Description": transaction.description,
      "Amount": transaction.amount || '-',
      "Currency": transaction.currency_type,
      "Date": formatDate(transaction.created_at),
      "Invest At": transaction.invest_at ? formatDate(transaction.invest_at) : '-'
    }));
    
    const csv = Papa.unparse(transformedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "TransactionData.csv");
  };



  React.useEffect(() => {
    handleLoadGetTransactionData();
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("User Bonus")} />
          <Row>
            <Row className="mb-2">
            <Col lg="12" className="d-flex justify-content-end">
                <Button
                type="button"
                onClick={handleDownloadCSV}
                color="primary"
                className="bx bx-download"
                >
                </Button>
            </Col>
            </Row>
            <Col lg="12">
              <Card>
                <CardBody>

                  <div className="table-responsive">
                    <table className="table mb-0" style={{ minWidth: '1000px' }}>
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Type</th>
                          <th>Amount</th>
                          <th>Currency</th>
                          <th>Date</th>
                          <th>Invest At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {TransactionTBody}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(UserBonus);
